/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Incode_LabelInputs */

const en_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const fr_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d'entrée`)
};

const de_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const it_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incodificare`)
};

const ru_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроенный код`)
};

const es_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incodificar`)
};

const zh_cn2_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const ja_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インコード`)
};

const hi_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड में`)
};

const pt_pt2_subtitle_export_incode_label = /** @type {(inputs: Subtitle_Export_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

/**
* | output |
* | --- |
* | "Incode" |
*
* @param {Subtitle_Export_Incode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_incode_label = /** @type {((inputs?: Subtitle_Export_Incode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Incode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_incode_label(inputs)
	if (locale === "de") return de_subtitle_export_incode_label(inputs)
	if (locale === "it") return it_subtitle_export_incode_label(inputs)
	if (locale === "ru") return ru_subtitle_export_incode_label(inputs)
	if (locale === "es") return es_subtitle_export_incode_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_incode_label(inputs)
	if (locale === "ja") return ja_subtitle_export_incode_label(inputs)
	if (locale === "hi") return hi_subtitle_export_incode_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_incode_label(inputs)
	return en_subtitle_export_incode_label(inputs)
});